import Card from "../../components/page/Card";
import React, { useState } from "react";
import CommonInput from "../../components/forms/CommonInput";
import CommonInputFile from "../../components/forms/CommonInputFile";
import CommonInputDate from "../../components/forms/CommonInputDate";
import CommonInputValor from "../../components/forms/CommonInputValor";
import CommonSelect from "../../components/forms/CommonSelect";
import CommonInputMask from "../../components/forms/CommonInputMask";
import CommonSwitch from "../../components/forms/CommonSwitch";
import CommonQuillEditor from "../../components/forms/CommonQuillEditor";
import useTipos from "../../hooks/common/useTipos";

function ElmentosFormulario() {
  const [values, setValues] = useState({
    inputTexto: "",
    inputQuill: "",
    inputArquivo: "",
    inputData: "",
    inputSelect: "",
    inputNumeral: "",
    inputMonetario: "",
    inputSwitch: false,
    inputMascara: "",
  });
  const tiposImpostos = useTipos("impostos");

  function handleChange(e, data, setData, name = null) {
    setData({ ...data, [name ?? e.target.name]: e.target.value });
  }

  function handleChangeCheck(e, data, setData) {
    const inputValue = e.target.checked;

    setData({ ...data, [e.target.name]: inputValue });
  }

  function handleChangeNumeral(e, data, setData) {
    const inputValue = e.target.value.replace(/[^0-9]/g, "");

    setData({ ...data, [e.target.name]: inputValue });
  }

  function handleChangeFile(e, data, setData) {
    setData({
      ...data,
      [e.target.name]: e.target.files ? e.target.files[0] : "",
    });
  }

  function handleChangeQuill(name, html, data, setData) {
    setData({ ...data, [name]: html });
  }

  return (
    <>
      <Card>
        <div className="row">
          <div className="col-md-6 mb-3">
            <CommonInput
              label="Texto"
              id="inputTexto"
              value={values.inputTexto}
              onChange={(e) => handleChange(e, values, setValues)}
            />
          </div>
          <div className="col-md-6 mb-3">
            <CommonInputFile
              label="Arquivo"
              id="inputArquivo"
              onChange={(e) => handleChangeFile(e, values, setValues)}
              accept="application/pdf"
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 mb-3">
            <CommonInputDate
              label="Data"
              id="inputData"
              value={values.inputData}
              onChange={(e) => handleChange(e, values, setValues)}
            />
          </div>
          <div className="col-md-6 mb-3">
            <CommonInputValor
              label="Monetário"
              id="inputMonetario"
              value={values.inputMonetario}
              onChange={(e) => {
                handleChangeQuill(
                  "inputMonetario",
                  e.target.value,
                  values,
                  setValues
                );
              }}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 mb-3">
            <CommonSelect
              label="Select"
              id="inputSelect"
              value={values.inputSelect}
              onChange={(e) => handleChange(e, values, setValues)}
              data={tiposImpostos.map((tipoImposto) => ({
                text: tipoImposto.valor,
                id: tipoImposto.chave,
              }))}
              placeholder="Selecione o módulo"
            />
          </div>
          <div className="col-md-6 mb-3">
            <CommonInput
              label="Numeral"
              id="inputNumeral"
              value={values.inputNumeral}
              onChange={(e) => handleChangeNumeral(e, values, setValues)}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 mb-3">
            <CommonInputMask
              label="Máscara"
              id="inputMascara"
              value={values.inputMascara}
              onChange={(e) => handleChange(e, values, setValues)}
              mask="(99)9 9999-9999"
            />
          </div>
          <div className="col-md-6 mb-3">
            <CommonSwitch
              label="Switch"
              id="inputSwitch"
              value={values.inputSwitch}
              onChange={(e) => handleChangeCheck(e, values, setValues)}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 mb-3">
            <CommonQuillEditor
              label="Quill"
              id="inputQuill"
              value={values.inputQuill}
              onChange={(html) =>
                handleChangeQuill("inputQuill", html, values, setValues)
              }
            />
          </div>
        </div>
      </Card>
    </>
  );
}

export default ElmentosFormulario;
